<script setup lang="ts">
import type { IColumnDefinition, RowData } from '../types';
import { dataTableMessages } from '../../../messages';

defineProps<{
  value: any;
  row: RowData;
  column: IColumnDefinition;
}>();
</script>

<template>
  <div class="d-flex justify-content-center align-items-center h-100">
    <iconify-icon
      v-if="value"
      noobserver
      icon="mdi:lock"
      class="text-danger"
      style="font-size: 1.2em"
      :title="dataTableMessages.locked"
    />

    <iconify-icon
      v-else
      noobserver
      icon="mdi:lock-open-variant"
      class="text-muted opacity-25"
      style="font-size: 1.2em"
      :title="dataTableMessages.unlocked"
    />
  </div>
</template>
